import { AdSlot } from '@/components/blog/AdSlot';

// Bloco de anúncio das páginas de loja/produto/ofertas. Sempre longe dos botões "Ir à loja".
export function ShopAd({ className }: { className?: string }) {
  return <div className={className}><AdSlot slot="shop-inline" format="auto" /></div>;
}
